<template>
  <div class="table100 ver1">
    <table data-vertable="ver1" v-if="userData.length">
      <thead>
        <tr class="row100 head">
          <th class="column100 column2 text-center" colspan="2">{{title}}</th>
        </tr>
        <tr class="row100 head">
          <th class="column100 column2" data-column="column2">{{columnOne}}</th>
          <th class="column100 column3" data-column="column3">{{units}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" v-for="(item, index) in userData" :key="item.user + index">
          <td class="column100 column1" data-column="column1">
            <a href="javascript:void(0)" @click="$emit('itemClick',item.user)">{{item.user}}</a></td>
          <td class="column100 column2" data-column="column2">{{item.value}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableData",
  data() {
    return {};
  },
  props: {
    userData: {
      type: Array,
      default: () => []
    },
    columnOne: {
      type: String,
      default: ""
    },
    units: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
